import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
//import 'hammerjs';
import { bootstrapApplication } from '@angular/platform-browser';
import { MobileAppComponent } from './app/mobile.app.component';
import { mobileAppConfig } from './app/mobile.app.config';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(MobileAppComponent, mobileAppConfig).then(() => {
  // if ('serviceWorker' in navigator && environment.production) {
  //   navigator.serviceWorker.register('/ngsw-worker.js');
  // }
}).catch(err => console.log(err));
